import { Badge } from '@/components/ui/badge';
import { Shield, MapPin } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const TrustBadges = () => {
  const { t } = useTranslation();
  
  return (
    <section className="py-12 border-y border-border bg-muted/30">
      <div className="container mx-auto px-4">
        <p className="text-center text-sm font-semibold text-muted-foreground mb-6">
          {t('landing.trustBadges.trustedBy')}
        </p>
        
        <div className="flex flex-wrap justify-center items-center gap-6 max-w-4xl mx-auto">
          <Badge variant="outline" className="flex items-center gap-2 px-4 py-2">
            <Shield className="w-4 h-4 text-primary" />
            {t('landing.trustBadges.gdprCompliant')}
          </Badge>
          
          <Badge variant="outline" className="flex items-center gap-2 px-4 py-2">
            <MapPin className="w-4 h-4 text-primary" />
            {t('landing.trustBadges.euHosted')}
          </Badge>
        </div>

        <div className="flex justify-center items-center gap-8 mt-8 flex-wrap opacity-40">
          <span className="text-2xl font-bold text-muted-foreground">{t('landing.trustBadges.airbnb')}</span>
          <span className="text-2xl font-bold text-muted-foreground">{t('landing.trustBadges.vrbo')}</span>
          <span className="text-2xl font-bold text-muted-foreground">{t('landing.trustBadges.bookingCom')}</span>
        </div>
      </div>
    </section>
  );
};
